import { combineReducers } from 'redux';
import layout from './layout';
const rootReducer = combineReducers({
    layout,
});
export default rootReducer;
export { showModal, hideModal } from './layout';
export { getCurrentModal } from './selectors';
